import { useQuery } from '@tanstack/react-query';

import { pastExportsApi } from '@/features/DataHub/api/pastExports.api';
import { pastExportsKeys } from '@/features/DataHub/queries/keys/pastExports.keys';

export const usePastExports = () => {
  return useQuery({
    queryKey: pastExportsKeys.lists(),
    queryFn: () => pastExportsApi.fetchPastExports(),
    refetchInterval: query => {
      const data = query.state.data;
      const hasOngoing = data?.some(item => item.exportStatus === 'ongoing');
      return hasOngoing ? 1000 * 5 : false;
    }
  });
};
